import styled from "styled-components";
import CardForItem from "../../../applicationUI/CardForItem";
import LikeButton from "./LikeButton";
import CustomButton from "../../../helperComponents/CustomButton";
import { BiComment, BiDonateHeart } from "react-icons/bi";
import { useContext } from "react";
import Context from "../../../../Context";
import CommentList from "../../../applicationUI/commentsAndReplies/CommentList";
import contentCardButtonStyle from "../../../../data/contentCardButtonStyle";
import getImageURL from "../../../../controllers/getImageURL";
import goTo from "../../../../controllers/goTo";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import contentPurposeTypes from "../../../../data/contentPurposeTypes";
import ngoTypes from "../../../../data/ngoTypes";
import VolunteerButton from "./VolunteerButton";
import UserListOfLikes from "./UserListOfLikes";
import UserListOfVolunteers from "./UserListOfVolunteers";
import { MdOutlineLocationOn } from "react-icons/md";
import { HiOutlineLocationMarker } from "react-icons/hi";
import DonationInfo from "../profiles/DonationInfo";
import MessageBox from "../../../helperComponents/MessageBox";
import ReportActionButton from "../report/ReportActionButton";
import CertificateCardCore from "../certification/CertificateCardCore";
import { BsShare } from "react-icons/bs";
import shareExternally from "../../../../controllers/shareExternally";
import { PiShareFat } from "react-icons/pi";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 10px;
  color: var(--elementDim);
  width: 100%;
  gap: 10px;
  cursor: pointer;
  /* position: relative; */

  align-items: center;

  &:hover {
    background: var(--surface);
  }
`;

const Image = styled.img`
  height: 100px;
  width: 100px;
  border-radius: 10px;
  object-fit: cover;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  flex: 1;
`;

const PrimaryLine = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const SecondaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  margin-top: -3px;
`;

const TertiaryLine = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
`;

const Name = styled.div`
  font-size: 21px;
  font-weight: 900;
  color: var(--element);
`;

const BubbleText = styled.div`
  background-color: var(--surface);
  padding: 5px 12px;
  color: var(--element);
  border-radius: 15px;
  text-transform: capitalize;
`;

const TertiaryText = styled.div``;

const PrimaryInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
`;

const Buttons = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
`;

const VirtualCard = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

const PaddingForPopup = styled.div`
  padding: 25px;
`;

const OpenProfileButton = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 10px;
  border: 1px solid var(--accentDim);
  cursor: pointer;
`;

export default function ContentCard({ data, forReportPurposes }) {
  const { setForm } = useContext(Context);

  let bubbleLine = [
    {
      text: "@" + data.author.username,
      onClick: goTo(`/u/${data.author.username}`),
    },
    data.purpose && {
      text: parseDropDownValue({
        query: data.purpose,
        theArray: contentPurposeTypes,
      }),
    },
    data.type && {
      text: parseDropDownValue({
        query: data.type,
        theArray: ngoTypes,
      }),
    },
    data.state && {
      text: `${data.state}`,
    },
    data.city && {
      text: `${data.city}`,
    },

    data.likeCount && {
      text: `${data.likeCount} Likes`,
      onClick: openLikeList,
    },
  ];

  if (data.purpose == "VOLUNTEERS_NEEDED")
    bubbleLine.push({ text: "Volunteer List", onClick: openVolunteerList });

  if (data.isBanned) {
    return <MessageBox>This content is banned</MessageBox>;
  }

  if (data.isDeleted) {
    return null;
  }

  let additionalComp = null;

  if (data.ngo && data.notificationId) {
    additionalComp = (
      <CertificateCardCore data={data.data} ngo={data.ngo} user={data.author} />
    );
  }

  return (
    <CardForItem
      item={data}
      additionalComp={additionalComp}
      itemType={"CONTENT"}
      pagePath="c"
      itemId={data._id}
      editPath={"manage-post"}
      image={data.images[0]}
      bubbleLine={bubbleLine}
      title={data.title}
      description={data.description}
      buttons={[
        <OpenProfileButton
          onClick={goTo(`/u/${data.author.username}`)}
          src={getImageURL(data.author.profileImage, true)}
        />,
        <LikeButton
          status={data.isLiked}
          contentId={data._id}
          count={data.likeCount}
        />,
        data.purpose == "VOLUNTEERS_NEEDED" ? (
          <VolunteerButton
            status={data.hasVolunteered}
            contentId={data._id}
            count={data.volunteerCount}
          />
        ) : null,
        // data.purpose == "VOLUNTEERS_NEEDED" ? (
        //   <CustomButton
        //     style={{ ...contentCardButtonStyle }}
        //     onClick={openComments}
        //   >
        //     Volunteer List
        //   </CustomButton>
        // ) : null,
        data.purpose == "FUNDS_NEEDED" && (
          <CustomButton
            style={{ ...contentCardButtonStyle }}
            onClick={openDonationInfo}
            icon={<BiDonateHeart />}
          >
            Donate
          </CustomButton>
        ),
        data.hasLatLong && (
          <CustomButton
            iconStyle={{ fontSize: "20px" }}
            style={{ ...contentCardButtonStyle }}
            onClick={openInGoogleMaps}
            icon={<HiOutlineLocationMarker />}
          ></CustomButton>
        ),
        <CustomButton
          style={{ ...contentCardButtonStyle }}
          icon={<BiComment />}
          onClick={openComments}
        >
          {data.commentCount}
        </CustomButton>,
        <CustomButton
          style={{ ...contentCardButtonStyle }}
          icon={<PiShareFat />}
          onClick={doSharing}
        ></CustomButton>,

        forReportPurposes == true && (
          <ReportActionButton
            action="BAN"
            itemId={data._id}
            itemType="CONTENT"
          />
        ),
        forReportPurposes == true && (
          <ReportActionButton
            action="IGNORE"
            itemId={data._id}
            itemType="CONTENT"
          />
        ),
      ]}
    />
  );

  function doSharing() {
    shareExternally(`https://karunasocial.app/p/${data._id}`);
  }

  function openDonationInfo() {
    setForm({
      title: "Donation Info",
      component: <DonationInfo item={data.author} />,
    });
  }

  function openVolunteerList() {
    setForm({
      title: "Volunteers",
      component: <UserListOfVolunteers contentId={data._id} />,
    });
  }

  function openInGoogleMaps() {
    // Assuming your object has keys like data.latitude and data.longitude
    const { latitude, longitude } = data;

    if (!latitude || !longitude) {
      window.popupAlert("Latitude and Longitude not stated");
      return;
    }

    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, "_blank");
  }
  function openLikeList() {
    setForm({
      title: "Likes",
      component: <UserListOfLikes contentId={data._id} />,
    });
  }

  function openComments() {
    setForm({
      title: "Comments",
      component: (
        <PaddingForPopup>
          <CommentList contentId={data._id} />
        </PaddingForPopup>
      ),
    });
  }
}
